import { StandaloneTopBar } from '@/components/Layout/StandaloneTopBar'

const LAST_UPDATED = '18 June 2026'

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <StandaloneTopBar backTo="/" backLabel="Back to home" />
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-justify text-muted-foreground text-sm mb-8">Last updated: {LAST_UPDATED}</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
          <Section title="1. Introduction">
            CONORBIT ("we", "our", "us") operates the CONORBIT platform at conorbit.com.
            This policy explains how we collect, use and protect personal data when you use our services.
          </Section>

          <Section title="2. Data We Collect">
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>Account information: name, email address, password hash</li>
              <li>Professional information: employer, beats, accreditation history</li>
              <li>Usage data: pages visited, features used, login timestamps</li>
              <li>Content you submit: article URLs, event attendance records, award nominations</li>
              <li>Payment records: dues amounts and dates (no card details stored on our servers)</li>
            </ul>
          </Section>

          <Section title="3. How We Use Your Data">
            We use your data to provide and improve the CONORBIT platform, to verify journalist
            identity for accreditation, to enforce association dues enforcement rules, to compute
            coverage scores, and to send transactional communications related to your account.
            We do not sell your data to third parties.
          </Section>

          <Section title="4. Data Sharing">
            Your professional profile may be visible to Communications Officers at institutions
            you are accredited to, and to association administrators for member management.
            You can control contact visibility from your profile settings.
          </Section>

          <Section title="5. Data Retention">
            We retain your account data for as long as your account is active plus a minimum of
            3 years for audit purposes. You may request deletion by contacting us at
            privacy@conorbit.com; some data may be retained for legal or regulatory obligations.
          </Section>

          <Section title="6. Security">
            Data is stored in the European Union (Supabase / AWS eu-west-1). All connections
            are TLS-encrypted. Database access is protected by Row-Level Security policies
            that isolate institution data.
          </Section>

          <Section title="7. Cookies">
            We use essential session cookies only. No advertising or tracking cookies are used.
          </Section>

          <Section title="8. Your Rights">
            Under applicable data protection law you have the right to access, correct, port
            or erase your personal data. Contact privacy@conorbit.com.
          </Section>

          <Section title="9. Contact">
            CONORBIT · hello@conorbit.com · conorbit.com
          </Section>
        </div>
      </div>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="text-[15px] font-semibold mb-2">{title}</h2>
      <div className="text-[13.5px] text-muted-foreground leading-relaxed text-justify">{children}</div>
    </div>
  )
}
